module.exports = __webpack_public_path__ + "img/S-left.8d2c1c94.png";